import { FormControl, FormHelperText, styled } from '@mui/material';
import { MuiTelInput } from 'mui-tel-input';
import { Controller } from 'react-hook-form';

const CustomBorderTelInput = styled(MuiTelInput)`
    & .MuiOutlinedInput-root {
        &.Mui-focused fieldset {
            border-color: #3A3A3A;
        }
        & img {
            max-width: 75%;
        }
    }
`;

const AuthTelInput = (props) => {
    const {
        hookFormControl,
        varName,
        disabled = false,
        errorMessage = null,
        autoFocus = false,
        size = "small",
        inputProps = null,
        placeholder = ""
    } = props;

    return (
        <>
            <FormControl error={errorMessage !== null} size={size}>
                <Controller
                    name={varName}
                    control={hookFormControl}
                    render={({ field }) => (
                        <CustomBorderTelInput
                            id={varName}
                            disabled={disabled}
                            autoFocus={autoFocus}
                            placeholder={placeholder}
                            InputProps={{ 
                                className: "rounded-full font-['Poppins-Regular'] text-[15px] border-[#3A3A3A]", 
                                inputProps: { className: "text-center" } 
                            }}
                            defaultCountry="IN"
                            disableFormatting
                            disableDropdown
                            forceCallingCode
                            size={size}
                            inputProps={inputProps ?? {}}
                            {...field}
                            value={field.value ?? ""}
                        />
                        
                    )}
                />
                {errorMessage && (
                    <FormHelperText className="ml-0 font-['Poppins-Regular'] text-[11px]" id="component-error-text">
                        {errorMessage}
                    </FormHelperText>
                )}
            </FormControl>
        </>
    );
};

export default AuthTelInput;
